import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Container, Icon } from "semantic-ui-react";

class RemoveAttachmentEvent extends React.Component {
  static propTypes = {
    date: PropTypes.string,
    user: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { date, user, type, name } = this.props;

    return (
      <div data-component="timelineItem">
        <div className="bullet-pointer">
          <Icon color="grey" size="large" circular name="file outline" />
          <Icon color="red" name="remove" className="corner" />
        </div>
        <Container data-component="logDetails">
          <time>{date}</time>{" "}
          <FormattedMessage
            id="activity.timeline.event.removeAttachment"
            defaultMessage="activity.timeline.event.removeAttachment"
            values={{ type, name }}
          />
          <div className="user">{user}</div>
        </Container>
      </div>
    );
  }
}

export default RemoveAttachmentEvent;
